import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function glAccountDocumentReducer(state = initialstate.glAccountDocuments, action) {
	switch (action.type) {
		case types.DELETE_GLACCOUNT_DOCUMENT:
			if (action.response) {
				return action.response.data || state;
			}
			break;
		case types.ADD_GLACCOUNT_DOCUMENT: {
			if (action.response) {
				return action.response.data || state;
			}
		}
		default:
			return state;
	}
}
